// Localized ordinal helper. Worker code keeps using helpers.ordinal directly
// (e.g. "8th") for English source-of-truth strings. UI uses this helper to
// pick "8th" / "8" / etc. based on the current i18n language.
//
// Chinese has no ordinal suffix — we return the bare number and let the
// surrounding translation handle the "第 N 名" framing (i18n key with
// {{ordinal}} placeholder reads correctly in both languages).

import { helpers } from "./helpers.ts";
import i18n from "./i18n.ts";

export const ordinalLocalized = (n?: number | null): string => {
	if (n === undefined || n === null) return "";
	const lang = i18n.isInitialized ? i18n.language : "en";
	if (lang === "zh") {
		return String(n);
	}
	return helpers.ordinal(n);
};
